let questiones = document.querySelectorAll(".questiones");

// Open the first FAQ by default
if (questiones.length > 0) {
  const firstQuestione = questiones[0];
  firstQuestione.classList.add("active");
  const firstAnswer = firstQuestione.nextElementSibling;
  firstAnswer.style.maxHeight = firstAnswer.scrollHeight + "px";
}

questiones.forEach((questione) => {
  questione.addEventListener("click", (event) => {
    const active = document.querySelector(".questiones.active");
    if (active && active !== questione) {
      active.classList.remove("active");
      active.nextElementSibling.style.maxHeight = 0;
    }
    questione.classList.toggle("active");
    const answer = questione.nextElementSibling;
    if (questione.classList.contains("active")) {
      answer.style.maxHeight = answer.scrollHeight + "px";
    } else {
      answer.style.maxHeight = 0;
    }
  });
});
